import { gql } from '@apollo/client';
import { MESSAGE_FRAGMENT } from './queries';

/**
 * Mutation to send a message
 */
export const SEND_MESSAGE = gql`
  ${MESSAGE_FRAGMENT}
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      ...MessageFields
    }
  }
`;

/**
 * Mutation to create a short-lived handoff token for linking web session to a Telegram bot chat.
 */
export const CREATE_TELEGRAM_HANDOFF = gql`
  mutation CreateTelegramHandoff {
    createTelegramHandoff {
      token
      botUrl
    }
  }
`;
